import {css} from 'lit';
export const styles = css`:host{display:inherit}`;
export default styles;
